import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Código de proceso',
            headerName: getLocalizedString("processCode"),
            filter: 'agSetColumnFilter',
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            headerName: getLocalizedString("name"),
            field: 'Nombre',
            filter: 'agTextColumnFilter',
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Fecha de ejecución',
            headerName: getLocalizedString("executionDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Hora de ejecución',
            headerName: getLocalizedString("executionTime"),
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["Hora de ejecución"] || "")) || "";
            },
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Estado de programación',
            headerName: getLocalizedString("programmingStatus"),
            filter: "agSetColumnFilter",
            cellRenderer: "Renderer",
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Recibir aviso string',
            headerName: getLocalizedString("receiveNotice"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Usuario programador',
            headerName: getLocalizedString("programmerUser"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            headerName: getLocalizedString("namesAndLastnames"),
            field: 'Apellidos y nombres',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Alcance del proceso',
            headerName: getLocalizedString("processScope"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Colaboradores actuales para procesar',
            headerName: getLocalizedString("currentCollaboratorsToProcess"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Fecha de término',
            headerName: getLocalizedString("endDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Hora de término',
            headerName: getLocalizedString("endTime"),
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["Hora de término"] || "")) || "";
            },
        }
    },
    {
        pages: [paths.processScheduling],
        config: {
            field: 'Duración del proceso',
            headerName: getLocalizedString("processDuration"),
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["Duración del proceso"] || "")) || "";
            },
        }
    },
]